export default function() {
    initializeEditor();
    attachSendEmailEvent();
    initializeEmailMultiSelect();
}

function attachSendEmailEvent() {
    const $sendEmailButton = $('#send-email');

    $sendEmailButton.unbind('click');
    $sendEmailButton.bind('click', sendEmail);
}

function sendEmail() {
    let data = {
        subject: $('.js-subject').val(),
        template: $('#editor').data('kendoEditor').value(),
    };

    $.post('/EmailHub/SendEmail', data, (response) => {
        console.log('email sent');
    });
}

function initializeEmailMultiSelect() {
    $('.js-multiselect-emails').kendoMultiSelect({
        label: {
            content: 'Sender List',
            floating: true,
        },
        placeholder: 'Select Emails',
        autoBind: false,
        dataSource: {
            transport: {
                read: {
                    dataType: 'json',
                    type: 'POST',
                    url: '/EmailHub/GetEmails',
                },
            },
        },
    });
}

function initializeEditor() {
    const k_editor = $('#editor').kendoEditor({
        resizable: true,
        tools: [
            'undo',
            'redo',
            { name: 'separator1', type: 'separator' },
            {
                name: 'fontName',
                items: [
                    { text: 'Andale Mono', value: '"Andale Mono"' }, // Font-family names composed of several words should be wrapped in \" \"
                    { text: 'Arial', value: 'Arial' },
                    { text: 'Arial Black', value: '"Arial Black"' },
                    { text: 'Book Antiqua', value: '"Book Antiqua"' },
                    { text: 'Comic Sans MS', value: '"Comic Sans MS"' },
                    { text: 'Courier New', value: '"Courier New"' },
                    { text: 'Georgia', value: 'Georgia' },
                    { text: 'Helvetica', value: 'Helvetica' },
                    { text: 'Impact', value: 'Impact' },
                    { text: 'Symbol', value: 'Symbol' },
                    { text: 'Tahoma', value: 'Tahoma' },
                    { text: 'Terminal', value: 'Terminal' },
                    { text: 'Times New Roman', value: '"Times New Roman"' },
                    { text: 'Trebuchet MS', value: '"Trebuchet MS"' },
                    { text: 'Verdana', value: 'Verdana' },
                ],
            },
            'fontSize',
            'bold',
            'italic',
            'underline',
            'backColor',
            'foreColor',
            { name: 'separator2', type: 'separator' },
            'insertUnorderedList',
            'justifyLeft',
            'justifyCenter',
            'justifyRight',
            { name: 'separator3', type: 'separator' },
            'formatting',
            { name: 'separator4', type: 'separator' },
            'createLink',
            'unlink',
            'insertImage',
            { name: 'separator5', type: 'separator' },
            'tableWizard',
            'tableProperties',
            'tableCellProperties',
            'createTable',
            'addRowAbove',
            'addRowBelow',
            'addColumnLeft',
            'addColumnRight',
            'deleteRow',
            'deleteColumn',
            'mergeCellsHorizontally',
            'mergeCellsVertically',
            'splitCellHorizontally',
            'splitCellVertically',
            'tableAlignLeft',
            'tableAlignCenter',
            'tableAlignRight',
        ],
    }).data('kendoEditor');

    k_editor.value('<h3>Profit Share Plan Approval Notification</h3><p>The baseline profit share plan for project {{ProjectFullName}} has been approved by {{Approver}}. It is now available for you to review/approve on the Portal&nbsp;<a href=3D"http://portal.limbachinc.com" target=3D"_blank">Here</a></p><p></p>{{#FinalBonusPlans}}<table style=3D"width:681.41px;"><tbody><tr style=3D"height:100%;"><td style=3D"width:33.333333333333336%;">{{EmpId}}</td><td style=3D"width:33.333333333333336%;">{{FirstName}} {{LastName}}</td><td style=3D"width:33.333333333333336%;">{{TotalValue}}</td></tr></tbody></table>{{/FinalBonusPlans}}');
}
